import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { CoreModule } from "../core/core.module";
import { MatDialogModule } from "@angular/material/dialog";
import { AdvTradingEntryPointComponent } from "@modules/advanced-trading/adv-trading-entry-point/adv-trading-entry-point.component";
import { AdvTradingModalComponent } from "@modules/advanced-trading/adv-trading-modal/adv-trading-modal.component";
import { ToggleInputModule } from "@modules/shared/bp-toggle/toggle-input.module";
import { AdvTradingInfoCardComponent } from "@modules/advanced-trading/adv-trading-info-card/adv-trading-info-card.component";
import { ClickedOutsideDirective } from "@modules/core/components/base-modals/helpers/clicked-outside.directive";
import { ReactiveFormsModule } from "@angular/forms";
import { TermsAndConditionsUpdatesModule } from "@modules/shared/terms-and-conditions/components/terms-and-conditions-updates.module";

@NgModule({
	declarations: [AdvTradingEntryPointComponent, AdvTradingModalComponent, AdvTradingInfoCardComponent],
	exports: [AdvTradingEntryPointComponent, AdvTradingModalComponent, AdvTradingInfoCardComponent],
	imports: [
		CommonModule,
		RouterModule,
		CoreModule,
		MatDialogModule,
		ToggleInputModule,
		ClickedOutsideDirective,
		ReactiveFormsModule,
		TermsAndConditionsUpdatesModule
	]
})
export class AdvancedTradingModule {}
